import React from "react";
import { Button } from "@/components/ui/button";
import { Upload, X } from "lucide-react";

export default function ImageUpload({ label, value, onChange, testId, height = "h-20" }) {
  const inputRef = React.useRef(null);

  const handleFile = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    const reader = new FileReader();
    reader.onload = () => onChange(reader.result);
    reader.readAsDataURL(file);
  };

  return (
    <div className="space-y-2">
      {label && <label className="text-sm font-medium text-cass-navy/80">{label}</label>}
      <div className="flex items-center gap-3">
        {value ? (
          <div className="relative">
            <img src={value} alt={label} className={`${height} rounded-md border border-cass-border object-contain bg-white p-1`} />
            <button
              type="button"
              onClick={() => onChange(null)}
              data-testid={testId ? `${testId}-remove` : undefined}
              className="absolute -right-2 -top-2 rounded-full bg-destructive p-0.5 text-white"
            >
              <X className="h-3 w-3" />
            </button>
          </div>
        ) : (
          <div className={`${height} w-32 rounded-md border border-dashed border-cass-border bg-cass-surface flex items-center justify-center text-xs text-muted-foreground`}>
            No image
          </div>
        )}
        <Button type="button" variant="outline" size="sm" onClick={() => inputRef.current?.click()} data-testid={testId}>
          <Upload className="mr-2 h-4 w-4" /> Upload
        </Button>
        <input ref={inputRef} type="file" accept="image/*" className="hidden" onChange={handleFile} />
      </div>
    </div>
  );
}
